import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  encrypted: string = '';
  decrypted: string = '';

  constructor() {}

  encrypt(value: string): string {
    this.encrypted = CryptoJS.TripleDES.encrypt(
      value,
      '#489ljkdfs7lkjsdfkj'
    ).toString();
    return this.encrypted;
  }

  decrypt(value: string): string {
    this.decrypted = CryptoJS.TripleDES.decrypt(
      value,
      '#489ljkdfs7lkjsdfkj'
    ).toString(CryptoJS.enc.Utf8);
    return this.decrypted;
  }

  authDecrypt(value: string, sessionId: string): string {
    const key = sessionId.substring(0, 24);
    const decryptedString = CryptoJS.AES.decrypt(
      value,
      CryptoJS.enc.Utf8.parse(key),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
    if (!decryptedString) {
      return value;
    }
    return decryptedString;
  }
}
